import {React,useState,useEffect} from "react";
import './JSlider2.scss'
import { Splide , SplideSlide } from '@splidejs/react-splide';
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

const JSlider2= ({singleItem,items,handleSwipe}) => {
    const [getSlidesToShow,setSlidesToShow] = useState(4);
    const [getSliderContainerWidth,setSliderContainerWidth] = useState(0);

    useEffect( () => {
        window.addEventListener("resize", handleResize);
        handleResize();
   },[]);

   const handleResize=()=>{
    var width=window.innerWidth;
    var numShow=0;
    var containerWidth=0;
    if(width<572){
        numShow=1;
        containerWidth=width;
    }
    else if(width<730){
        numShow=1;
        containerWidth=width;
    }
    else if(width<950){
        numShow=2;
        containerWidth=width;
    }
    else if(width<1200){
        containerWidth=width-350;
        numShow=parseInt(containerWidth/300);
    }
    else{
        containerWidth=width-550;
        numShow=parseInt(containerWidth/300);
    }

    containerWidth=numShow*320;
    setSlidesToShow(numShow);
    setSliderContainerWidth(containerWidth);
    }

    return ( 
        <div className="slideContainer" style={{width:getSliderContainerWidth}} dir='ltr'>
            <Splide options={{
                rewind: false,
                perPage: getSlidesToShow,
                perMove: 1,
                autoplay: false,
                interval: 5000,
                lazyLoad: "nearby",
                arrows: true,
                pagination:false,
                direction:'rtl',
                classes: {
                    arrows: 'splideArrows',
                    arrow : 'splideArrow',
                    prev  : 'splideArrowNext',
                    next  : 'splideArrowPrev',
                },
                
            }}>
                {singleItem!=null ? <SplideSlide><div className="each-slide">{singleItem}</div></SplideSlide>: null}
                {items.map( (item,index) => (<SplideSlide key={index}><div className="each-slide">{item}</div></SplideSlide>))}
            </Splide>
        </div>
    );
}

export default JSlider2;
